import React from 'react';
import AnyError from "./anyError"
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Caught by ErrorBoundary:', error, errorInfo);
    // Optional: Log to external service like Sentry
  }

  handleRefresh = () => {
    this.setState({ hasError: false, error: null });
    // Optional: window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
      
        <AnyError/>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
